import React from 'react';
import { motion } from 'framer-motion';
import TermsAndConditions from '../components/UI/TermsAndConditions';
import SEOHead from '../components/UI/SEOHead';

const TermsPage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEOHead
        title="Términos y Condiciones"
        description="Términos y Condiciones de uso de la plataforma CRM RurayHUB de Ruray Digital. Planes, facturación, uso aceptable y legislación aplicable."
        path="/terminos-condiciones"
        noindex={false}
      />
      <TermsAndConditions />
    </motion.div>
  );
};

export default TermsPage;
